/** Tag-category sets API — named bundles applied to a TO's tag categories.
 *
 * Hand-authored wrapper. `/tag_category_sets/` CRUD; PATCH full-replaces items.
 */
import { apiDelete, apiGet, apiPatch, apiPost } from './client';
import type { PaginatedResponse } from './users';

export interface TagCategorySetItem {
  id?: number;
  code: string;
  name: string;
  sequence: number;
  is_multitag: boolean;
  state_category: boolean;
  accounting: boolean;
  billing: boolean;
  keyfield: string;
  association: Record<string, unknown> | null;
}

export interface TagCategorySet {
  id: number;
  code: string;
  name: string;
  label: string;
  restech: string;
  description: string;
  items: TagCategorySetItem[];
  created_ts: string;
  updated_ts: string;
}

export interface TagCategorySetWrite {
  code?: string;
  name?: string;
  label?: string;
  restech?: string;
  description?: string;
  items?: Omit<TagCategorySetItem, 'id'>[];
}

export interface ListParams {
  page?: number;
  pageSize?: number;
  ordering?: string;
  restech?: string;
}

function toQuery(params: ListParams): string {
  const usp = new URLSearchParams();
  if (params.page) usp.set('page', String(params.page));
  if (params.pageSize) usp.set('page_size', String(params.pageSize));
  if (params.ordering) usp.set('ordering', params.ordering);
  if (params.restech) usp.set('restech', params.restech);
  const qs = usp.toString();
  return qs ? `?${qs}` : '';
}

export function list(params: ListParams = {}): Promise<PaginatedResponse<TagCategorySet>> {
  return apiGet(`/tag_category_sets/${toQuery(params)}`);
}
export function retrieve(id: number): Promise<TagCategorySet> {
  return apiGet(`/tag_category_sets/${id}/`);
}
export function create(body: TagCategorySetWrite): Promise<TagCategorySet> {
  return apiPost('/tag_category_sets/', body);
}
export function update(id: number, body: TagCategorySetWrite): Promise<TagCategorySet> {
  return apiPatch(`/tag_category_sets/${id}/`, body);
}
export function remove(id: number): Promise<void> {
  return apiDelete(`/tag_category_sets/${id}/`);
}
